import PropTypes from 'prop-types';
import { Box } from '@mui/material';

export default function DeploymentLogoImage({ src, alt }) {
    return (
        <Box
            sx={{
                width: 50,
                height: 50,
                borderRadius: '50%',
                overflow: 'hidden',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#f1f1f1'
            }}
        >
            <img
                src={src}
                alt={alt}
                style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain'
                }}
            />
        </Box>
    );
}

DeploymentLogoImage.propTypes = {
    src: PropTypes.string,
    alt: PropTypes.string
};
